import {DateTime} from 'luxon'
import {isRef} from 'vue'

//Test for ISO date string
export function isISODateString(str) {
  return str.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.*/)
}

//Helper to convert a value from JSON
export function valueFromJSON(value) {
  if (Array.isArray(value)) {
    return value.map(valueFromJSON)
  }
  else if (typeof value === 'string') {
    if (isISODateString(value)) {
      const date = DateTime.fromISO(value)
      if (date.isValid) {
        return date
      }
    }
    return value
  }
  else if (value && typeof value === 'object') {
    if (value.isModel || value.isLuxonDateTime) {
      return value
    }
    const copy = {}
    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        copy[key] = valueFromJSON(value[key])
      }
    }
    return copy
  }
  return value
}

//Helper to convert a value to JSON
export function valueToJSON(value) {
  if (isRef(value)) {
    value = value.value
  }
  if (Array.isArray(value)) {
    return value.map(valueToJSON)
  }
  else if (value && typeof value === 'object') {
    if (value instanceof File) {
      return value
    }
    if (value.isModel) {
      return value.toJson()
    }
    else if (value.isLuxonDateTime) {
      return value.toISO()
    }
    const copy = {}
    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        copy[key] = valueToJSON(value[key])
      }
    }
    return copy
  }
  return value
}

//Convert string to camel case
export function toCamelCase(str) {
  if (typeof str === 'number') {
    return String(str)
  }
  else if (typeof str !== 'string') {
    return ''
  }
  if ((str = String(str).trim()) === '') {
    return ''
  }
  return str
    .replace(/_+|-+/g, ' ')
    .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) => {
      if (Number(match) === 0) {
        return ''
      }
      return (index === 0) ?
        match.toLowerCase() : match.toUpperCase()
    })
}

//Convert string to snake case
export function toSnakeCase(str, uppercase = false) {
  if (typeof str === 'number') {
    return String(str)
  }
  else if (typeof str !== 'string') {
    return ''
  }
  if ((str = String(str).trim()) === '') {
    return ''
  }
  str = str.replace(/(\s*-*\b\w|[A-Z])/g, ($1) => {
    $1 = $1.trim().toLowerCase().replace('-', '')
    return ($1[0] === '_' ? '' : '_') + $1
  }).slice(1)
  if (uppercase) {
    return str.toUpperCase()
  }
  return str
}

//Replace unicode characters by strings
export function replaceUnicode(str) {
  return JSON.parse(`["${str}"]`)[0]
}

//Truncate a string
export function truncate(str, maxCharacters, ending = '...') {
  if (maxCharacters === null || maxCharacters === undefined) {
    return str
  }
  if (str.length <= maxCharacters) {
    return str
  }
  return `${str.slice(0, maxCharacters)}${ending}`
}

//Pluralize a word
export function pluralize(noun) {
  const immutable = [
    'media',
  ]
  if (immutable.includes(noun)) {
    return noun
  }
  else if (noun.endsWith('y')) {
    return `${noun.substring(0, noun.length - 1)}ies`
  }
  else if (
    noun.endsWith('ch') ||
    noun.endsWith('sh') ||
    noun.endsWith('x') ||
    noun.endsWith('z') ||
    noun.endsWith('s') ||
    noun.endsWith('o')
  ) {
    return `${noun}es`
  }
  return `${noun}s`
}

//Inflection helper
export function inflect(noun, count, includeCount = false) {
  const inflected = count === 1 ? noun : pluralize(noun)
  return includeCount ? `${count} ${inflected}` : inflected
}
